import { toCustomDateRange } from "../../../utils/date-range";
import moment from 'moment-timezone';
var Utils = {
  withLeadingZero: function withLeadingZero(num) {
    return num.toString().length === 1 ? "0" + num : String(num);
  },
  numberWithCommas: function numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  },
  humanizeSeconds: function humanizeSeconds(seconds) {
    var result = seconds.toString();

    if (seconds > -1) {
      // seconds
      result = Math.floor(seconds % 60) + "s";
    } else {
      return result;
    }

    if (seconds > 60) {
      // minutes
      result = Math.floor(seconds / 60) % 60 + "m" + result;
    } else {
      return result;
    }

    if (seconds > 3600) {
      // hours
      result = Math.floor(seconds / 3600) % 24 + "h" + result;
    } else {
      return result;
    }

    if (seconds > 86400) {
      // days (hide days when years)
      var value = Math.floor(seconds / 86400) % 365;

      if (value > 0) {
        result = value + "d " + result;
      }
    } else {
      return result;
    }

    if (seconds >= 86400) {
      // years
      var value = Math.floor(seconds / (86400 * 365));

      if (value === 1) {
        result = value + "yr " + result;
      } else if (value > 1) {
        result = value + "yrs " + result;
      }
    }

    return result;
  },
  secondsToMinutes: function secondsToMinutes(value, withSeconds) {
    var seconds = Utils.withLeadingZero(Math.floor(+value % 60));
    var minutes = Utils.withLeadingZero(Math.floor(+value / 60));
    return String(minutes + (withSeconds ? ":" + seconds : ''));
  },
  getStartEndDates: function getStartEndDates(timeRange, timezone) {
    if (timezone === void 0) {
      timezone = moment.tz.guess();
    }

    var customDateRange = toCustomDateRange(timeRange, timezone);
    var start = moment(customDateRange.start).tz(timezone).utc();
    var end = moment(customDateRange.end).tz(timezone).utc();
    return {
      type: 'absolute',
      start: start,
      end: end
    };
  },
  getLegendPosition: function getLegendPosition(position) {
    var positions = ['top', 'bottom', 'left', 'right'];
    return positions.find(function (pos) {
      return pos === position;
    }) || positions[0];
  },
  getExportFileName: function getExportFileName(title) {
    return [title ? title.replace(' ', '_') : 'Analytics_Chart', moment().format('YYYYMMDDHHMMSS')].join('_');
  },
  getExportFileHeading: function getExportFileHeading(title, timeRange) {
    if (!timeRange) {
      return title;
    } // TODO support period


    var _a = Utils.getStartEndDates(timeRange),
        start = _a.start,
        end = _a.end;

    var dateFormat = 'MM/DD/YYYY hh:mm A';
    var fromDate = moment(start).format(dateFormat);
    var toDate = moment(end).format(dateFormat);
    return title + " \r\n " + fromDate + " - " + toDate;
  },
  getExportOptions: function getExportOptions(title, timeRange) {
    var A4 = {
      width: 523.28,
      height: 769.89
    };
    return {
      enabled: true,
      fileName: Utils.getExportFileName(title),
      menu: [{
        class: 'export-main',
        label: 'Export',
        menu: [{
          format: 'PDF',
          content: [Utils.getExportFileHeading(title, timeRange), {
            image: 'reference',
            fit: [A4.width, A4.height]
          }]
        }, 'PNG', 'JPG']
      }]
    };
  }
};
export default Utils;